export const swipeDialogClasses = {
  root: 'DhlSwipeDialog-root',
  body: 'DhlSwipeDialog-body',
  backdrop: 'DhlSwipeDialog-backdrop',
  dialogHeader: 'DhlSwipeDialog-dialogHeader',
}
